import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

export function useInternalChatPro() {
  const currentUser = useMapGetter('getCurrentUser');
  const currentRole = useMapGetter('getCurrentRole');

  return {
    pollsEnabled: computed(() => true),
    maxPrivateChannels: computed(() => null),
    searchHistoryDays: computed(() => null),
    isSuperAdmin: computed(() => currentUser.value?.type === 'SuperAdmin'),
    isAdmin: computed(() => currentRole.value === 'administrator'),
  };
}
